import React from 'react'
import { debounce } from 'lodash'
import {
  Form, FormGroup, ControlLabel, FormControl,
  Panel, Button, Modal, Checkbox, Row, Col
} from 'react-bootstrap'

import { PriceEditor } from '../components/Price'
import CitySelector from '../cities/CitySelector'
import { getText, nameOrTitle } from '../lib/text'
import FilesSelector from '../lib/FilesSelector'
import CommutingForm from '../routes/components/CommutingForm'
import { fetchGeolocation } from '../lib/AppTools'
import MarkdownField from '../lib/MarkdownField'
import TranslateLink from './TranslateLink'

const labelWidth = 75
const longLabelWidth = 140

const titleStyle = {  fontSize: 16, fontWeight: 400, margin: 0 }

const MyFormGroup = ({ children, controlId }) => (
  <FormGroup
    bsSize="small"
    controlId={controlId}
    style={{ display: "block", marginBottom: 5 }}
  >
    {children}
  </FormGroup>
)

export class ExpenseEditor extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = { searchedAddress: null, geolocation: null }
    this.dataForGeolocation = {}
    this.debouncedGeolocation = debounce((address) => {
      this.getGeolocation(address)
    }, 1000, { trailing : true })
  }

  getGeolocationText() {
    const g = this.props.expense.preciseLocation
    return g ? `${g.address} (${g.longitude}, ${g.latitude})` : "..."
  }

  onChange(changes) {
    const {editItem, routeId, i, referencedExpense, agendaItem, isGeneralExpense, onChange, expense} = this.props
      onChange(changes)
  }

  getGeolocation(address) {
    const { expense } = this.props
    const encodedAddress = encodeURIComponent(`${address}, ${expense.city}`)
    this.setState({searchedAddress : encodedAddress})
    if (!expense.preciseLocation || encodedAddress != expense.preciseLocation.queryAddress) {
      fetchGeolocation(encodedAddress).then(geolocation => {
        if (encodedAddress == this.state.searchedAddress) {
          this.onChange({
            preciseLocation: {
              address: geolocation.formatted_address,
              longitude: geolocation.geometry.location.lng,
              latitude: geolocation.geometry.location.lat,
              queryAddress : address
            }
          })
        }
      })
    }
  }

 

  render() {
    const {
      expense,               // expense object to edit
      agendaItem = null,     // item in the agenda, if approp, to edit commuting info (and more?)
      pickCity = false,      // include city picker
      pickType = false,      // include type picker
      isGeneralExpense = false,
      routeId,
      onChange,
      i
    } = this.props

    const nameLabelsWidth = (pickCity || pickType) ? labelWidth : longLabelWidth

    return (
      <div style={{ padding: 5 }}>
        <Form inline>
          <Row>
            <Col md={(pickCity || pickType) ? 6 : 9}>

              <MyFormGroup controlId={`expense-name`} >
                <ControlLabel style={{ width: nameLabelsWidth }}>{getText("spanish_name")}: </ControlLabel>
                <FormControl
                  name="name"
                  value={expense.name ||  ""}
                  onChange={evt => {
                    if (evt.target.value.includes("hotel") || evt.target.value.includes("Hotel")) {
                      onChange({ name: evt.target.value, type: "hotel" })
                    }
                    else {
                      onChange({ name: evt.target.value })
                    }
                  }}
                />
              </MyFormGroup>

              <MyFormGroup controlId={`expense-title`} >
                <ControlLabel style={{ width: nameLabelsWidth }}>{getText("chinese_title")}: </ControlLabel>
                <FormControl
                  title="title"
                  value={expense.title ||  ""}
                  onChange={evt => onChange({ title: evt.target.value })}
                />
                <TranslateLink text={expense.title ||  ""} />
              </MyFormGroup>

              <Checkbox
                style={{ marginTop: 15, marginBottom: 15, display: "block" }}
                checked={!!expense.useCustomFee}
                onChange={evt => onChange({ useCustomFee : evt.target.checked })}
              >
                {`  ${getText("Cambiar gastos de gestión (sólo para este ítem)")}`}
              </Checkbox>

              {
                expense.useCustomFee && (
                  <FormGroup style={{ display: "block", marginBottom : 15 }}>
                    <ControlLabel>{getText("Nuevo % gestión")}</ControlLabel>
                    <FormControl
                      style={{ marginLeft: 10 }}
                      type="number"
                      value={expense.customFee || 0}
                      onChange={evt => onChange({ customFee: parseFloat(evt.target.value) })}
                    />
                  </FormGroup>
                )
              }

            </Col>

            {
              (pickCity || pickType) && (
                <Col md={6}>

                  {
                    pickCity && (
                      <div style={{ marginTop: 5, marginBottom: 10 }}>
                        <Checkbox
                          checked={!expense.city}
                          onChange={evt => (
                            evt.target.checked
                              ? onChange({ city: null, previousCity: expense.city })
                              : onChange({ city: expense.previousCity || "Madrid" })
                          )}
                        >
                          {getText("Gasto válido para cualquier ciudad")}
                        </Checkbox>
                        <CitySelector
                          cityId={expense.city || expense.previousCity || null}
                          onChange={city => onChange({ city })}
                          labelWidth={labelWidth}
                          disabled={!expense.city}
                        />
                      </div>
                    )
                  }

                  {
                    pickType && (
                      <MyFormGroup controlId="expensetypeselect" style={{ marginTop: 10, marginBottom: 10 }}>
                        <ControlLabel style={{ width: labelWidth }}>{getText("Tipo")}: </ControlLabel>
                        <FormControl
                          componentClass="select"
                          placeholder="select"
                          value={expense.type || null}
                          style={{ minWidth: 180 }}
                          onChange={evt => onChange({ type: evt.target.value })}
                        >
                          <option value="normal" key="nullType">{getText("Normal")}</option>
                          <option value="hotel" key="hotel">{getText("Hotel")}</option>
                        </FormControl>
                      </MyFormGroup>
                    )
                  }

                </Col>
              )
            }

          </Row>
        </Form>

        <Panel>
          <Panel.Body>
            <Row style={{ marginTop: 10 }}>
              <Col md={6}>
                <h3 style={titleStyle}>{getText("Precio (para el cliente)")}</h3>
                <PriceEditor
                  price={expense.price}
                  onChange={price => onChange({ price })}
                />
              </Col>

              <Col md={6}>
                <h3 style={titleStyle}>{getText("Coste (para nosotros)")}</h3>
                <PriceEditor
                  price={expense.cost}
                  onChange={cost => onChange({ cost })}
                />
              </Col>
            </Row>
          </Panel.Body>
        </Panel>

        <FilesSelector
          includeNotes
          title={"Imágenes"}
          value={{ expenseImg: null, ...expense.files }}
          fileNotes={expense.fileNotes}
          onChange={files => onChange({ files })}
          onNotesChange={fileNotes => onChange({ fileNotes })}
          labels={{ expenseImg: getText("Imagen para App"), }}
          extensions={{ expenseImg: ["jpeg", "jpg", "png"], }}
        />

        {
          !isGeneralExpense && (
            <Row style={{ marginTop: 10 }}>
              <Col md={6}>
                <MyFormGroup controlId="address">
                  <ControlLabel>
                    <div style={{ width: labelWidth }}>{getText("Dirección")}: </div>
                  </ControlLabel>
                  <FormControl
                    title="Dirección"
                    value={expense.address ||  ""}
                    onChange={evt => {
                      onChange({address : evt.target.value})
                      this.debouncedGeolocation(evt.target.value)
                    }}
                  />
                </MyFormGroup>
                <span>Geolocation: {this.getGeolocationText()}</span>
              </Col>
              <Col md={4}>
                {
                  agendaItem && (
                    <CommutingForm
                      item={agendaItem}
                      onChange={(k, v) => this.props.editItem( routeId,  i, k, v)}
                    />
                  )
                }
              </Col>
            </Row>
          )
        }

        <Row style={{marginTop: 10}}>
          <Col md={6}>
            <MarkdownField
              label={getText("🇨🇳 Notas para el cliente")}
              smallLabel={<span>{getText("(app)")} <TranslateLink text={expense.clientNotes || ""} /></span>}
              value={expense.clientNotes || ""}
              onChange={clientNotes => onChange({ clientNotes })}
              style={{marginBottom: 5}}
            />
          </Col>
          <Col md={6}>
            <MarkdownField
              label={getText("🇪🇸 Notas internas")}
              smallLabel={getText("(códigos, duración...)")}
              value={expense.notes || ""}
              onChange={notes => onChange({ notes })}
              style={{marginBottom: 5}}
            />
          </Col>
        </Row>

      </div>
    )
  }
}

export const ModalExpenseEditor = (props) => (
  <Modal show bsSize="large" className="modal-expense-editor" onHide={() => props.onClose()}>
    <Modal.Header>
      <Modal.Title>{nameOrTitle(props.expense)}</Modal.Title>
    </Modal.Header>

    <Modal.Body style={{ minWidth: 900, width: 900 }}>
      <ExpenseEditor {...props} />
    </Modal.Body>

    <Modal.Footer>
      <Button onClick={() => props.onClose()} bsStyle="primary">{getText("OK")}</Button>
    </Modal.Footer>

  </Modal>
)
